import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';

export const GetAnonUserCountQuery = gql`
  query getAnonUserCount($id: Long!) {
    anonUserConversionCount(id: $id) {
      payload
      failure {
        ... on AnonUserCriteriaCreationFailure {
          message
        }
        ... on AnonUserCriteriaInvalidSearchQuery {
          message
        }
        ... on AnonUserCriteriaNameAlreadyExistsFailure {
          message
        }
        ... on AnonUserCriteriaNotFoundFailure {
          message
        }
        ... on AnonUserCriteriaUpdateFailure {
          message
        }
      }
    }
  }
`;

export const useQueryAnonUserCount = (criteriaId: number) => {
  const { data, errorMessage, isLoading, refetch } = useGraphql(GetAnonUserCountQuery, {
    fetchPolicy: 'network-only',
    variables: { id: criteriaId },
    notifyOnNetworkStatusChange: true,
  });

  return {
    count: data?.anonUserConversionCount?.payload,
    errorMessage: data?.failure?.message || errorMessage?.message,
    isLoading,
    refetch,
  };
};
